import { useTranslation } from '@wix/yoshi-flow-editor';
import classNames from 'classnames';
import type { FC } from 'react';
import React, { useRef } from 'react';

import { RepositionButton } from '../../../../../../common/components/RepositionButton';
import { useWidget } from '../../../../../../contexts/widgets';
import { DataHook } from '../../../../../../types';
import { Loader } from '../common';
import styles from './Cover.scss';
import { CoverButtons } from './CoverButtons';
import { CoverImage } from './CoverImage';
import { CoverRepositionButtons } from './CoverRepositionButtons';
import { useCover } from './useCover';

export const Cover: FC = () => {
  const { t } = useTranslation();
  const { computed, profilePage } = useWidget();

  const coverRef = useRef<HTMLDivElement>(null);

  const { showCoverPhoto, canEdit } = computed;
  const { isCoverLoading, isCoverRepositionMode, isProfilePreview } =
    profilePage;

  const {
    isCoverMoving,
    actions: {
      handleCoverPositionChange,
      startRepositioningCover,
      stopRepositioningCover,
    },
  } = useCover(coverRef);

  return (
    <div data-hook={DataHook.CoverWrapper} className={styles.container}>
      {isCoverRepositionMode && !isCoverMoving && <CoverRepositionButtons />}
      <div
        ref={coverRef}
        className={styles.borderMargin}
        onMouseDown={startRepositioningCover}
        onMouseUp={stopRepositioningCover}
        onMouseLeave={stopRepositioningCover}
      >
        <CoverImage />
        {isCoverLoading && <Loader />}
        {isCoverRepositionMode && !isCoverLoading && (
          <RepositionButton
            text={t('profile-widget.drag-to-reposition')}
            dataHook={DataHook.DragToChangeCoverPositionCTA}
            className={classNames(
              styles.repositionCoverButton,
              isCoverMoving && styles.coverIsMoving,
            )}
            onKeyDown={handleCoverPositionChange}
          />
        )}
      </div>

      {showCoverPhoto &&
        canEdit &&
        !isCoverRepositionMode &&
        !isProfilePreview && <CoverButtons />}
    </div>
  );
};
